import React from "react";
import { Panel, SectionGrid, SummaryGrid } from "../AdminAnalyticsCards";
import CssBarChart from "../charts/CssBarChart";
import AdminAnalyticsTable, { UserCell } from "../tables/AdminAnalyticsTable";
import { aa, formatDay, formatLabel, formatNumber, getUserLabel, getUserSubLabel } from "../adminAnalyticsUtils";
function formatUsersSublabel(count) {
  return aa("users_sublabel", "{{count}} users", {
    count: formatNumber(count),
  });
}
export default function AdminAnalyticsMapSpotsTab({
  data
}) {
  const summary = data?.summary || {};
  const tripsSummary = data?.tripsSummary || {};
  return <>
      <SummaryGrid cards={[{
      label: aa("map_spots", "Map spots"),
      value: formatNumber(summary.mapSpots)
    }, {
      label: aa("public_spots", "Public spots"),
      value: formatNumber(summary.publicMapSpots)
    }, {
      label: aa("private_spots", "Private spots"),
      value: formatNumber(summary.privateMapSpots)
    }, {
      label: aa("spot_images", "Spot images"),
      value: formatNumber(summary.spotImages)
    }, {
      label: aa("favorite_spots", "Favorite spots"),
      value: formatNumber(summary.favoriteSpots)
    }, {
      label: aa("trips", "Trips"),
      value: formatNumber(summary.trips)
    }, {
      label: aa("trip_catches", "Trip catches"),
      value: formatNumber(summary.tripCatches)
    }, {
      label: aa("map_users", "Map users"),
      value: formatNumber(summary.usersUsingMap)
    }, {
      label: aa("map_events", "Map events"),
      value: formatNumber(summary.mapEvents)
    }]} />


      <SectionGrid>
        <CssBarChart title={aa("map_activity_by_day", "Map activity by day")} rows={data?.mapActivityByDay} getLabel={row => formatDay(row?.day)} getValue={row => row?.mapEvents} getSublabel={row => formatUsersSublabel(row?.uniqueUsers)} />

        <CssBarChart title={aa("map_events_by_name", "Map events by name")} rows={data?.mapEventsByName} getLabel={row => row?.eventName || aa("unknown", "Unknown")} getValue={row => row?.eventCount} getSublabel={row => formatUsersSublabel(row?.uniqueUsers)} />

        <CssBarChart title={aa("spots_by_visibility", "Spots by visibility")} rows={data?.spotsByVisibility} getLabel={row => formatLabel(row?.visibility)} getValue={row => row?.count} />

        <Panel title={aa("trips_summary", "Trips summary")}>
          <div className="admin-analytics-completion-grid">
            {[[aa("trips", "Trips"), tripsSummary.trips], [aa("trip_catches", "Trip catches"), tripsSummary.tripCatches], [aa("planned", "Planned"), tripsSummary.planned], [aa("past", "Past"), tripsSummary.past], [aa("current", "Current"), tripsSummary.current]].map(([label, value]) => <div className="admin-analytics-completion-item" key={label}>
                <span>{label}</span>
                <strong>{formatNumber(value)}</strong>
              </div>)}
          </div>
        </Panel>
        <AdminAnalyticsTable title={aa("top_map_users", "Top map users")} rows={data?.topMapUsers} rowKey={row => getUserSubLabel(row)} columns={[{
        header: aa("user", "User"),
        render: row => <UserCell title={getUserLabel(row)} subtitle={getUserSubLabel(row)} />
      }, {
        header: aa("spots", "Spots"),
        render: row => formatNumber(row?.spotCount)
      }, {
        header: aa("favorite_spots", "Favorite spots"),
        render: row => formatNumber(row?.favoriteSpotCount)
      }, {
        header: aa("map_events", "Map events"),
        render: row => formatNumber(row?.mapEventCount)
      }]} />

      </SectionGrid>
    </>;
}
